import { Injectable, Injector } from '@angular/core';

import { ItemType } from '@firestitch/filter';
import { nameValue } from '@firestitch/common';

import { map } from 'rxjs/operators';

import { AttributeData, StatusData } from '@app/core/data';
import { AttributeClass, ObjectClass } from '@app/common/enums';
import { Project } from '@app/common/interfaces';

import { FilterConfigService } from './filter-config.service';
import { SessionService } from './session.service';


@Injectable()
export class ImageFilterConfigService extends FilterConfigService {

  constructor(
    private _attributeData: AttributeData,
    private _statusData: StatusData,
    private _sessionService: SessionService,
    protected _injector: Injector,
  ) {
    super(_injector);
    this._init();
  }

  public setContext(project: Project = null) {
    this._init(project);

    return this;
  }

  private _init(project: Project = null) {
    this._filters = [
      this.createFilterKeyword(),
      this.createFilterStatus(ObjectClass.AssetImage),
      {
        name: 'tagAttributeIds',
        type: ItemType.AutoCompleteChips,
        label: 'Tags',
        values: (keyword) => {
          const query: any = { keyword, class: AttributeClass.Tag };

          if (project) {
            query.projectId = project.id;
          } else {
            query.environmentId = this._sessionService.environmentId();
          }

          return this._attributeData.gets(query)
            .pipe(map((response) => nameValue(response, 'name', 'id')));
        },
      },
      {
        name: 'state',
        type: ItemType.Checkbox,
        label: 'Show Deleted',
        unchecked: 'active',
        checked: 'deleted',
      },
      /*
      {
        name: 'state',
        type: ItemType.Select,
        label: 'Status',
        values: [
          { name: 'All', value: '__all' },
          { name: 'Active', value: 'active' },
          { name: 'Deleted', value: 'deleted' },
        ],
        isolate: { label: 'Show Deleted', value: 'deleted' },
      },
      */
    ];
  }

}
